<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 4845 632"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-miterlimit: 10"
  >
    <path
      id="tassel-secondary-color"
      d="M4842.98,604.614l-19.372,-8.254l-103.755,2.335c-2.715,0.055 -4.962,-2.144 -5.009,-4.924c-0.07,-2.773 2.106,-5.059 4.806,-5.115l104.504,-2.342l18.826,18.3Zm-276.135,-75.472l138.379,12.461c2.708,0.247 4.721,2.693 4.494,5.457c-0.249,2.797 -2.629,4.852 -5.344,4.613l-137.529,-12.397l0,-10.134Zm267.927,-31.039c2.731,-0.072 5.001,2.095 5.064,4.892c0.078,2.764 -2.076,5.083 -4.791,5.162l-268.2,8.453l0,-10.07l267.927,-8.437Zm8.208,34.21l-91.444,-8.891c-2.7,-0.263 -4.681,-2.717 -4.432,-5.481c0.258,-2.757 2.653,-4.796 5.352,-4.533l90.524,8.811l-0,10.094Zm-0,-75.957l-121.177,-6.995c-2.723,-0.144 -4.821,-2.526 -4.665,-5.299c0.164,-2.764 2.473,-4.915 5.188,-4.764l120.654,6.987l-0,10.071Zm-276.135,1.888l121.575,-7.155c2.691,-0.183 5.032,1.968 5.164,4.725c0.149,2.796 -1.935,5.162 -4.657,5.298l-122.082,7.218l0,-10.086Zm0,-27.805l274.84,-8.78c0.452,0 0.881,0.048 1.295,0.152l-0,9.775c-0.328,0.08 -0.656,0.144 -1.007,0.144l-275.128,8.779l0,-10.07Zm0,-60.534l276.135,0l-0,10.095l-276.135,-0l0,-10.095Zm268.068,-41.149c2.738,-0 4.946,2.262 4.946,5.035c-0,2.796 -2.208,5.059 -4.946,5.059l-155.465,-0c-2.708,-0 -4.939,-2.263 -4.939,-5.059c0,-2.773 2.231,-5.035 4.939,-5.035l155.465,-0Zm8.067,-31.861l-109.747,-15.679l-166.388,3.107l0,-10.062l166.372,-3.107c0.351,-0.024 0.679,-0.016 1.046,0.04l108.717,15.536l-0,10.165Zm-276.135,-69.639l156.277,-3.155c2.715,-0.048 4.962,2.175 5.024,4.947c0.039,2.757 -2.122,5.083 -4.821,5.123l-156.48,3.131l0,-10.046Zm276.135,-3.442l-112.072,-20.197l-164.063,6.948l0,-10.071l163.907,-6.931c0.429,-0.064 0.897,-0.04 1.365,0.056l110.863,19.965l-0,10.23Zm-276.135,-68.421l276.135,-7.537l-0,10.071l-276.135,7.544l0,-10.078Zm276.135,-15.751l-160.365,-24.212l-115.77,5.219l0,-10.071l115.559,-5.218c0.383,-0.04 0.781,-0.032 1.225,0.032l159.351,24.068l-0,10.182Zm-0,-102.934l-39.212,20.531c-0.796,0.406 -1.669,0.582 -2.52,0.534l0,0.008l-125.522,-7.051c-2.707,-0.167 -4.798,-2.533 -4.642,-5.298c0.141,-2.78 2.481,-4.908 5.188,-4.756l124.204,6.979l42.504,-22.228l-0,11.281Zm-4842.98,-9.322l19.372,8.254l103.755,-2.335c2.715,-0.047 4.962,2.144 5.001,4.924c0.078,2.773 -2.099,5.059 -4.798,5.115l-104.504,2.342l-18.826,-18.3Zm276.135,75.472l-138.38,-12.461c-2.699,-0.247 -4.72,-2.693 -4.494,-5.457c0.242,-2.797 2.637,-4.852 5.345,-4.613l137.529,12.397l-0,10.134Zm-267.928,31.039c-2.73,0.072 -5,-2.095 -5.063,-4.892c-0.078,-2.764 2.075,-5.083 4.79,-5.162l268.201,-8.453l-0,10.07l-267.928,8.437Zm-8.207,-34.21l91.444,8.891c2.7,0.263 4.681,2.717 4.431,5.481c-0.257,2.757 -2.652,4.796 -5.352,4.533l-90.523,-8.811l0,-10.094Zm0,75.957l121.177,6.995c2.722,0.144 4.821,2.526 4.665,5.306c-0.164,2.757 -2.473,4.908 -5.188,4.757l-120.654,-6.987l0,-10.071Zm276.135,-1.888l-121.575,7.163c-2.699,0.175 -5.032,-1.976 -5.165,-4.733c-0.148,-2.796 1.935,-5.162 4.658,-5.298l122.082,-7.218l-0,10.086Zm-0,27.805l-274.84,8.78c-0.452,-0 -0.882,-0.048 -1.295,-0.152l0,-9.775c0.328,-0.08 0.655,-0.144 1.006,-0.144l275.129,-8.779l-0,10.07Zm-0,60.534l-276.135,-0l0,-10.095l276.135,0l-0,10.095Zm-268.068,41.149c-2.738,0 -4.946,-2.262 -4.946,-5.035c-0,-2.796 2.208,-5.059 4.946,-5.059l155.465,0c2.707,0 4.939,2.263 4.939,5.059c-0,2.773 -2.232,5.035 -4.939,5.035l-155.465,0Zm-8.067,31.861l109.747,15.679l166.388,-3.107l-0,10.062l-166.38,3.107c-0.344,0.024 -0.671,0.016 -1.038,-0.04l-108.717,-15.536l0,-10.165Zm276.135,69.639l-156.277,3.155c-2.715,0.048 -4.962,-2.175 -5.024,-4.947c-0.039,-2.757 2.122,-5.083 4.821,-5.123l156.48,-3.131l-0,10.046Zm-276.135,3.442l112.064,20.197l164.071,-6.948l-0,10.071l-163.907,6.931c-0.429,0.064 -0.897,0.04 -1.365,-0.056l-110.863,-19.957l0,-10.238Zm276.135,68.421l-276.135,7.537l0,-10.071l276.135,-7.544l-0,10.078Zm-276.135,15.751l160.365,24.212l115.77,-5.219l-0,10.071l-115.56,5.218c-0.382,0.04 -0.78,0.032 -1.225,-0.032l-159.35,-24.068l0,-10.182Zm0,102.934l39.212,-20.531c0.795,-0.406 1.669,-0.582 2.519,-0.534l0,-0.008l125.523,7.051c2.707,0.167 4.798,2.533 4.642,5.298c-0.149,2.78 -2.481,4.908 -5.189,4.756l-124.203,-6.979l-42.504,22.228l0,-11.281Z"
      :style="{
        fill: productColors.secondary_1.value,
        stroke: 'rgb(204, 204, 204)',
        strokeWidth: '2.11px',
        transition: 'all 500ms',
      }"
    />
    <path
      id="tassel-primary-color"
      d="M4566.84,491.316l0,-10.195l267.927,-8.437c2.153,-0.069 4.02,1.268 4.744,3.204l3.464,-0.068l-0,10.062l-276.135,5.434Zm0,-76.242l0,-14.248l80.997,1.599l193.843,-6.193c0.452,0 0.881,0.032 1.295,0.152l-0,9.783c-0.178,0.035 -0.355,0.072 -0.536,0.098l0.536,0.011l-0,10.046l-119.154,-2.348l119.154,6.884l-0,10.071l-121.177,-6.995c-2.723,-0.144 -4.821,-2.526 -4.665,-5.298c0.144,-2.437 1.944,-4.387 4.221,-4.711l-73.219,-1.442l-81.295,2.591Zm0,-146.644l0,-19.596l166.372,-3.123c0.351,-0.016 0.679,0 1.046,0.056l99.559,14.227l-0.953,-7.347l-50.181,-4.374c-2.707,-0.207 -4.728,-2.669 -4.502,-5.433c0.211,-2.773 2.622,-4.828 5.313,-4.621l54.113,4.717l0,0.008c2.286,0.191 4.197,1.983 4.494,4.35l0.874,6.716l-0,17.459l-6.075,-0.869l-270.06,-2.17Zm195.54,-8.481l-29.152,-4.167l-146.654,2.745l175.806,1.422Zm-195.54,-70.098l0,-14.783l113.958,-4.836c-0.312,-0.636 -0.497,-1.349 -0.521,-2.107c-0.078,-2.764 2.083,-5.083 4.791,-5.163l157.907,-4.565l-0,39.99l-5.207,-0.938l-270.928,-7.598Zm181.966,-18.666l89.969,16.216l3.872,0.108l-0,-19.033l-93.841,2.709Zm22.731,14.333l-40.634,-7.319l-88.021,3.718l128.655,3.601Zm-2.935,-154.998l-64.014,13.072c-0.242,0.048 -0.508,0.088 -0.773,0.096l-136.975,14.922l0,-5.154l-38.93,-0c0.702,-0.55 1.536,-0.901 2.465,-0.988l172.395,-18.787l26.334,-5.379l-53.375,-2.999c-2.715,-0.167 -4.806,-2.517 -4.642,-5.314c0.148,-2.764 2.473,-4.891 5.18,-4.748l91.559,5.151l59.334,-12.121l15.815,-8.271l-0,15.333l-12.687,2.591l-26.525,13.888c-0.796,0.407 -1.669,0.582 -2.52,0.534l0,0.008l-32.641,-1.834Zm-20.444,69.371l-65.548,-9.903l-115.77,5.226l0,-10.07l97.369,-4.397c-0.803,-0.952 -1.262,-2.211 -1.197,-3.566c0.164,-2.764 2.481,-4.907 5.188,-4.772l174.775,10.174l-0,10.086l-122.265,-7.106l93.188,14.066l29.077,-0.116l-0,14.702l-30.027,-4.536l-246.108,0.98l0,-10.047l181.318,-0.721Zm90.519,477.465l-271.837,-3.239l0,-10.054l148.591,1.779c0.818,-1.528 2.398,-2.58 4.214,-2.613l104.504,-2.342l6.517,6.335l12.309,0.147l-0,10.039l-1.854,-0.023l1.854,1.802l-4.298,-1.831Zm-230.8,-232.862l-41.037,-2.56l0,-10.086l202.809,12.646l50.104,0l23.222,-23.721l-0,14.277l-9.252,9.444l9.252,0l-0,10.087l-19.133,-0l-1.558,1.59l-0.023,-0c-0.944,0.98 -2.301,1.554 -3.76,1.466l-48.979,-3.056l-202.682,-0l0,-10.087l41.037,0Zm66.977,-37.985l-108.014,-1.478l0,-10.039l234.723,3.195c2.731,0.04 4.9,2.326 4.876,5.107c-0,0.011 -0,0.023 -0.001,0.035l28.47,-0c2.738,-0 4.946,2.255 4.946,5.043c-0,2.788 -2.208,5.043 -4.946,5.043l-155.465,0c-2.708,0 -4.939,-2.255 -4.939,-5.043c0,-0.658 0.124,-1.287 0.35,-1.863Zm168.121,317.442l-92.763,-12.357c-2.699,-0.351 -4.595,-2.868 -4.244,-5.617c0.343,-2.772 2.824,-4.7 5.516,-4.366l91.491,12.206l-0,10.134Zm-0,-71.456l-146.415,-5.537c-2.739,-0.104 -4.869,-2.422 -4.767,-5.195c0.101,-2.788 2.395,-4.955 5.102,-4.868l146.08,5.553l-0,10.047Zm-276.135,-412.016l160.95,-1.027c2.731,-0.024 4.938,2.223 4.962,5.011c-0,2.781 -2.2,5.035 -4.915,5.043l-160.997,1.028l0,-10.055Zm0,363.237l138.379,12.46c2.708,0.255 4.721,2.693 4.494,5.457c-0.249,2.797 -2.629,4.844 -5.344,4.613l-137.529,-12.396l0,-10.134Zm276.135,3.171l-91.444,-8.9c-2.7,-0.263 -4.681,-2.7 -4.432,-5.465c0.258,-2.757 2.653,-4.804 5.352,-4.541l90.524,8.803l-0,10.103Zm-276.135,-74.07l121.575,-7.186c2.691,-0.152 5.032,1.984 5.164,4.756c0.149,2.781 -1.935,5.163 -4.657,5.298l-122.082,7.218l0,-10.086Zm0,-231.004l156.277,-3.139c2.715,-0.04 4.962,2.167 5.024,4.947c0.039,2.765 -2.122,5.059 -4.821,5.115l-156.48,3.147l0,-10.07Zm0,-71.847l276.135,-7.529l-0,10.063l-276.135,7.544l0,-10.078Zm-4563.38,26.145l-3.463,0.068l0,-10.062l276.135,-5.434l-0,10.196l-267.928,8.437c-2.153,0.069 -4.02,-1.269 -4.744,-3.205Zm115.669,61.914l-119.132,-6.883l0,-10.071l121.177,6.995c2.722,0.144 4.821,2.526 4.665,5.298c-0.144,2.435 -1.942,4.384 -4.216,4.71l73.229,1.443l81.28,-2.591l-0,14.247l-80.982,-1.598l-193.858,6.193c-0.452,-0 -0.882,-0.032 -1.295,-0.152l0,-9.783c0.179,-0.035 0.358,-0.072 0.54,-0.099l-0.54,-0.01l0,-10.047l119.132,2.348Zm-119.132,159.972l0,-17.466l6.069,0.868l270.066,2.17l-0,19.597l-166.38,3.123c-0.344,0.016 -0.671,-0 -1.038,-0.056l-99.559,-14.227l0.953,7.346l50.181,4.374c2.707,0.207 4.728,2.669 4.501,5.433c-0.21,2.773 -2.621,4.828 -5.313,4.621l-54.112,-4.716l-0,-0.008c-2.286,-0.192 -4.198,-1.984 -4.494,-4.35l-0.874,-6.709Zm256.43,-4.525l-175.842,-1.421l29.159,4.167l146.683,-2.746Zm-256.43,100.13l0,-39.989l5.201,0.937l270.934,7.598l-0,14.784l-113.958,4.836c0.312,0.635 0.497,1.349 0.52,2.106c0.078,2.765 -2.083,5.083 -4.79,5.163l-157.907,4.565Zm200.02,-23.516l-128.58,-3.603l40.624,7.318l87.956,-3.715Zm-105.86,10.729l-90.015,-16.218l-3.817,-0.107l-0,19.034l93.832,-2.709Zm-94.16,171.185l0,-15.334l12.689,-2.591l26.523,-13.887c0.795,-0.407 1.669,-0.582 2.519,-0.534l0,-0.008l32.639,1.833l64.017,-13.072c0.242,-0.048 0.507,-0.088 0.772,-0.096l136.976,-14.922l-0,5.155l38.93,-0c-0.702,0.549 -1.537,0.9 -2.465,0.988l-172.395,18.794l-26.313,5.374l53.354,2.997c2.715,0.167 4.806,2.517 4.642,5.314c-0.148,2.764 -2.473,4.891 -5.181,4.748l-91.545,-5.15l-59.347,12.12l-15.815,8.271Zm0,-99.514l0,-14.701l30.021,4.535l246.114,-0.98l-0,10.047l-181.323,0.722l65.553,9.903l115.77,-5.226l-0,10.07l-97.369,4.397c0.803,0.952 1.261,2.211 1.197,3.565c-0.164,2.764 -2.481,4.907 -5.189,4.772l-174.774,-10.174l0,-10.086l122.256,7.106l-93.185,-14.066l-29.071,0.116Zm1.853,-477.872l-1.853,-1.801l4.296,1.83l271.839,3.239l-0,10.054l-148.594,-1.779c-0.815,1.528 -2.395,2.581 -4.211,2.614l-104.504,2.342l-6.518,-6.335l-12.308,-0.148l0,-10.038l1.853,0.022Zm7.398,232.892l-9.251,-0l0,-10.087l19.132,0l1.558,-1.591l0.024,0c0.944,-0.98 2.301,-1.553 3.76,-1.466l48.991,3.057l202.67,0l-0,10.087l-41.025,-0l41.025,2.559l-0,10.087l-202.797,-12.646l-50.117,-0l-23.221,23.72l0,-14.277l9.251,-9.443Zm27.285,41.165l-28.469,0c-2.738,0 -4.946,-2.255 -4.946,-5.043c-0,-2.788 2.208,-5.043 4.946,-5.043l155.465,-0c2.707,-0 4.939,2.255 4.939,5.043c-0,0.658 -0.125,1.286 -0.35,1.862l108.014,1.479l-0,10.038l-234.723,-3.195c-2.731,-0.04 -4.9,-2.326 -4.876,-5.107c-0,-0.011 -0,-0.022 0,-0.034Zm-36.536,-320.623l92.763,12.357c2.699,0.351 4.595,2.876 4.244,5.617c-0.344,2.772 -2.824,4.7 -5.516,4.366l-91.491,-12.206l0,-10.134Zm0,71.457l146.415,5.537c2.739,0.103 4.868,2.422 4.767,5.194c-0.101,2.789 -2.395,4.956 -5.102,4.868l-146.08,-5.553l0,-10.046Zm276.135,412.015l-160.95,1.027c-2.731,0.024 -4.939,-2.222 -4.962,-5.011c-0,-2.78 2.2,-5.035 4.907,-5.043l161.005,-1.028l-0,10.055Zm-0,-363.236l-138.38,-12.46c-2.699,-0.255 -4.72,-2.693 -4.494,-5.457c0.242,-2.797 2.637,-4.844 5.345,-4.613l137.529,12.396l-0,10.134Zm-276.135,-3.171l91.444,8.9c2.7,0.263 4.681,2.7 4.431,5.465c-0.257,2.757 -2.652,4.804 -5.352,4.541l-90.523,-8.803l0,-10.103Zm276.135,74.07l-121.575,7.186c-2.699,0.152 -5.032,-1.984 -5.165,-4.756c-0.148,-2.781 1.935,-5.163 4.658,-5.298l122.082,-7.218l-0,10.086Zm-0,231.004l-156.277,3.139c-2.715,0.04 -4.962,-2.167 -5.024,-4.947c-0.039,-2.765 2.122,-5.059 4.821,-5.115l156.48,-3.147l-0,10.07Zm-0,71.847l-276.135,7.529l0,-10.063l276.135,-7.544l-0,10.078Z"
      :style="{
        fill: productColors.secondary_2.value,
        transition: 'all 500ms',
      }"
    />
    <rect
      id="scarf-primary-color"
      x="270.8"
      y="51.228"
      width="4312.06"
      height="527.298"
      :style="{
        fill: productColors.primary_1.value,
        transition: 'all 500ms',
        stroke: '#373737',
        strokeWidth: '2',
      }"
    />
    <path
      id="scarf-secondary-color"
      d="M1443.04,51.228l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm-71.066,0l0,527.298l-299.266,0l-0,-527.298l299.266,0Zm-335.139,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm1206.27,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm-71.074,0l0,527.298l-299.266,0l-0,-527.298l299.266,0Zm-335.131,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm1206.25,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm-71.058,0l0,527.298l-299.267,0l0,-527.298l299.267,0Zm-335.139,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm1206.26,0l0,527.298l-35.045,0l-0,-527.298l35.045,0Zm-71.058,0l-0,527.298l-299.267,0l0,-527.298l299.267,0Zm-335.139,0l-0,527.298l-35.045,0l-0,-527.298l35.045,0Z"
      :style="{
        fill: productColors.primary_2.value,
        transition: 'all 500ms',
      }"
    />
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip5">
      <rect
        id="right-logo-mask"
        x="3945.86"
        y="51.228"
        width="390"
        height="527.298"
        style="fill: none"
      />
    </clipPath>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip1">
      <rect
        id="text-mask-1"
        x="1073.25"
        y="51.228"
        width="297.888"
        height="527.298"
        style="fill: none"
      />
    </clipPath>
    <g
      v-if="text.type !== 'front'"
      xmlns="http://www.w3.org/2000/svg"
      clip-path="url(#_clip1)"
    >
      <g id="text-mask-11" serif:id="text-mask-1">
        <g
          id="custom-text-1"
          transform="matrix(4.97332e-17,1,-1,7.35526e-17,7332.2,-25632.5)"
        >
          <g transform="matrix(250,0,0,250,26179.1,6197.52)"></g>
          <text
            x="25950px"
            y="6130px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message2 }}
          </text>
        </g>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip2">
      <rect
        id="text-mask-2"
        x="1872.69"
        y="51.228"
        width="299.232"
        height="527.298"
        style="fill: none"
      />
    </clipPath>
    <g
      v-if="text.type !== 'front'"
      xmlns="http://www.w3.org/2000/svg"
      clip-path="url(#_clip2)"
    >
      <g
        id="custom-text-2"
        transform="matrix(4.97332e-17,1,-1,7.35526e-17,8121.6,-26421.9)"
      >
        <g transform="matrix(250,0,0,250,26968.5,6197.52)"></g>
        <text
          x="26740px"
          y="6130px"
          text-anchor="middle"
          :style="{
            fontSize: `${text.size}px`,
            fill: text.color.value,
            transition: 'all 500ms',
            fontFamily: `${text.font}`,
            transform: `translate(0px, ${text.size / 7}px `,
          }"
        >
          {{ text.message2 }}
        </text>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip3">
      <rect
        id="text-mask-3"
        x="2673.31"
        y="51.228"
        width="300.134"
        height="527.298"
        style="fill: none"
      />
    </clipPath>
    <g
      v-if="text.type !== 'front'"
      xmlns="http://www.w3.org/2000/svg"
      clip-path="url(#_clip3)"
    >
      <g id="text-mask-3" serif:id="text-mask-3">
        <g
          id="custom-text-3"
          transform="matrix(7.01906e-17,-1,1,5.15068e-17,-22206,-2646.19)"
        >
          <g transform="matrix(250,0,0,250,-2729.31,25127.5)"></g>
          <text
            x="-2960px"
            y="25054.8px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message }}
          </text>
        </g>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip4">
      <rect
        id="text-mask-4"
        x="3472.86"
        y="51.228"
        width="299.342"
        height="527.298"
        style="fill: none"
      />
    </clipPath>
    <g
      v-if="text.type !== 'front'"
      xmlns="http://www.w3.org/2000/svg"
      clip-path="url(#_clip4)"
    >
      <g
        id="custom-text-4"
        transform="matrix(7.01906e-17,-1,1,5.15068e-17,-21402,-1842.25)"
      >
        <g transform="matrix(250,0,0,250,-1925.37,25127.5)"></g>
        <text
          x="-2160px"
          y="25054.8px"
          text-anchor="middle"
          :style="{
            fontSize: `${text.size}px`,
            fill: text.color.value,
            transition: 'all 500ms',
            fontFamily: `${text.font}`,
            transform: `translate(0px, ${text.size / 7}px `,
          }"
        >
          {{ text.message }}
        </text>
      </g>
    </g>
    <defs>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "Scarf_4",
  props: ["productColors", "logo", "text"],
  setup(props) {
    const fontFace = computed(() => getFontFace(props.text.font));
    return {
      fontFace,
    };
  },
};
</script>
